

// returns the absolute URL of public assets.

// why is this required? some assets need to be shared outside the app, like logos that show also in email messages. 
// but public assets may not be imported in the source code, they need to be referenced (eg. in <img> tags).
// the public url must include the app's "base url" as configured in the build tool. absoluteOf() does that.

// note: this is vite specific, removed earlier setup for abstracting over the tool as changes are too rare to justify it.

export const usePublicUrl = () => {

    const self = {

        baseUrl: (import.meta as any).env.BASE_URL ?? "/",

        // derived util.
        absoluteOf: (path: string) => `${self.baseUrl}/${path}`.replace(/\/{2,}/g, "/")

    }

    return self
}

